/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Unlink_SuccessInputs */

const fr_guardian_unlink_success = /** @type {(inputs: Guardian_Unlink_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enfant délié`)
};

/**

* @param {Guardian_Unlink_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_unlink_success = /** @type {((inputs?: Guardian_Unlink_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Unlink_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_unlink_success(inputs)
});